import { LOGO_SRC } from '../constants/brand';

const Logo = ({ className = 'w-18 h-12' }) => (
  <img
    src={LOGO_SRC}
    alt="Cynopsis"
    className={`${className} object-contain object-left`}
    style={{ filter: 'none' }}
  />
);

export default Logo;
